import { useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import Cookie from 'js-cookie'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import {
  DEFAULT_DATA,
  InternshipRequestPortalFormContext, Modes
} from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import PortalRequesterForm from './PortalRequesterForm'
import { isValid } from '../../utils/validators'
import { StudentValidators } from '../../utils/entities/student'
import { getRedirectAction } from '../../utils/api/student'
import { Cookies } from '../../utils/Cookie'
import { StorageKeys } from '../../Providers/AuthProvider'
import { RedirectActions } from '../../Providers/Forms/InternshipRequestPortal/RedirectStudentModal'
import { Properties } from '../../utils/entities'
import { onWarning } from '../../utils/apiHelper'
import { HttpStatuses } from '../../utils/http'
import ActivationPendingModal from './ActivationPendingModal'

const InterneoAccountForm = ({ institutionName = '', visible = false, onHasAccount, onPortalRedirection }) => {
  const { setFormHandler } = useContext(InternshipRequestPortalFormContext)
  const { setStudentEmail } = useContext(RequestPortalContext)

  const t = useSelector(selectTranslate)

  const [email, setEmail] = useState('')
  const [redirectAction, setRedirectAction] = useState('')
  const [errorFields, setErrorFields] = useState([])
  const [loading, setLoading] = useState(false)

  const enterWizard = () => {
    onPortalRedirection(Modes.STUDENT)
    setFormHandler({ data: DEFAULT_DATA[Modes.STUDENT], mode: Modes.STUDENT })
  }

  const redirectToLogin = () => {
    Object.values(Cookies).forEach(value => Cookie.remove(value))
    window.localStorage.removeItem(StorageKeys.ACCOUNT_ID)

    onHasAccount()
  }

  const handleSubmit = event => {
    event.preventDefault()

    // A trailing space is invisible in the field and used to make the lookup answer "compte
    // introuvable" on a perfectly existing account: validate and search the trimmed address.
    const trimmedEmail = email.trim()

    const errors = isValid({ email: trimmedEmail }, [StudentValidators.email]).keys

    setErrorFields(errors)

    if (errors.length !== 0) {
      return
    }

    setLoading(true)

    getRedirectAction(trimmedEmail).then(({ data }) => {
      setStudentEmail(trimmedEmail)

      if (data === RedirectActions.REDIRECTION) {
        redirectToLogin()
      } else {
        setRedirectAction(data)
      }
    }).catch(response => {
      // No account behind that address: the portal is the way to create one.
      if (response.status !== HttpStatuses.NOT_FOUND) {
        onWarning(t('interneo_account_form.requester.check_unavailable'))
      }

      enterWizard()
    }).finally(() => setLoading(false))
  }

  if (!visible) {
    return null
  }

  return (
    <>
      <ActivationPendingModal
        visible={redirectAction === RedirectActions.WITH_REMINDER}
        onCancel={() => setRedirectAction('')}
        onConfirm={redirectToLogin}
      />

      <PortalRequesterForm
        email={email}
        emailLabel='interneo_account_form.requester.email'
        hasEmailError={errorFields.includes(Properties.EMAIL)}
        helpLabel='interneo_account_form.requester.email_help'
        institutionName={institutionName}
        loading={loading}
        title='internship_request_portal.title'
        onEmailChange={event => setEmail(event.target.value)}
        onHasAccount={redirectToLogin}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default InterneoAccountForm
